import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../header/service/category.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  public categories: any = [];
  GlobalImage;
  constructor(private categoryService: CategoryService) { }

  ngOnInit(): void {
    debugger;
    this.categoryService.getCategories().subscribe(res => {
      this.categories = res;
      this.categories.forEach(element => {
        element.categoryImage = environment.globalImagePath + 'CategoryImage/' + element.categoryImage;
        element.categories1.forEach(element => {
          element.categoryImage = environment.globalImagePath + 'CategoryImage/' + element.categoryImage;
        });
      });

    });
  }
  categoryselect(id) {
    debugger;

  }

}
